import React, { useContext, useState } from 'react';
import ButtonComponent from '@/components/Button';
import { useTranslation } from 'react-i18next';
import { ReactComponent as EditIcon } from '@/assets/images/icons/edit.svg';
import { getLanguageName } from '@/helpers/language';
import { renderTimeZoneString } from '@/helpers';
import { GlobalContext } from '@/contexts/GlobalContext';
import ModalAccountComponent from './ModalAccount';

import './index.scss';

function AccountComponent() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const { currentUser, setTriggerFetchProfile } = useContext(GlobalContext);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setTriggerFetchProfile(true);
  };

  return (
    <div className="profile-content">
      <div className="profile-content__image">
        {currentUser?.avatar ? (
          <div className="group-image-upload">
            <img
              src={currentUser?.avatar}
              alt="SMS2BUY"
              width="100%"
              height="100%"
              className="upload-img"
            />
          </div>
        ) : (
          <div className="group-image-upload">
            <p className="group-image-text fw-600">
              {currentUser?.firstName?.slice(0, 1)}
            </p>
          </div>
        )}
        <p className="group-name fw-600">
          {currentUser?.firstName} {currentUser?.lastName}
        </p>
      </div>
      <div className="profile-content__info">
        <p className="profile-items">
          <span className="profile-items__title">
            {t('profile_page.account.merchant_id')}
          </span>
          <span className="profile-items__value">{currentUser?.id}</span>
        </p>
        <p className="profile-items">
          <span className="profile-items__title">{t('common.email')}</span>
          <span className="profile-items__value">{currentUser?.email}</span>
        </p>
        <p className="profile-items">
          <span className="profile-items__title">
            {t('profile_page.account.first_name')}
          </span>
          <span className="profile-items__value">{currentUser?.firstName}</span>
        </p>
        <p className="profile-items">
          <span className="profile-items__title">
            {t('profile_page.account.last_name')}
          </span>
          <span className="profile-items__value">{currentUser?.lastName}</span>
        </p>
        <p className="profile-items">
          <span className="profile-items__title">
            {t('profile_page.account.timezone')}
          </span>
          <span className="profile-items__value">
            {renderTimeZoneString(currentUser?.timezone)}
          </span>
        </p>
        <p className="profile-items">
          <span className="profile-items__title">
            {t('profile_page.account.language')}
          </span>
          <span className="profile-items__value">
            {getLanguageName(currentUser?.language)}
          </span>
        </p>
      </div>
      <ButtonComponent
        onClick={showDrawer}
        icon={<EditIcon />}
        className="btn-edit"
      >
        {t('button.edit')}
      </ButtonComponent>
      <ModalAccountComponent
        open={open}
        onClose={onClose}
        profileData={currentUser}
      />
    </div>
  );
}

export default AccountComponent;
